(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("learningItemSeminarsResource", ["$resource", learningItemSeminarsResource]);
    function learningItemSeminarsResource($resource) {
        return $resource("/api/learningItemSeminars/:id/:action", { id: "@id", action: "@action" }, {
            getSeminarListViewModel: {
                method: "POST",
                params: { action: "seminarListViewModel" }
            },
            getCreateSeminarViewModel: {
                method: "GET",
                params: { action: "createSeminarViewModel" }
            },
            update: {
                method: "PUT",
                params: { id: "@id" }
            },
            getRegisteredLearners: {
                method: "GET",
                params: { action: "registeredLearners" },
                isArray: true
            },
            updateAttendance: {
                method: "POST",
                params: { action: "updateAttendance" }
            },
            removeRegistrant: {
                method: "POST",
                params: { action: "removeRegistrants" }
            },
            getAssignedLearners: {
                method: "GET",
                params: { action: "getAssignedLearners" },
                isArray: true
            },
            addLearnerToSeminar: {
                method: "POST",
                params: { action: "addLearnerToSeminar" }
            },
            addCompletedLearners: {
                method: "POST",
                params: { action: "addCompletedLearners" }
            },
            getAddCompletedLearnersViewModel: {
                method: "GET",
                params: { action: "addCompletedLearnersViewModel" }
            }
        });
    }
}());
